module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "todo-list"
  }, _vm._l((_vm.todos), function(todo) {
    return _c('todo', {
      attrs: {
        "todo": todo
      },
      on: {
        "delete-todo": _vm.deleteTodo,
        "complete-todo": _vm.completeTodo,
        "update:todo": function($event) {
          todo = $event
        }
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8e0deeb4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/todo/TodoList.vue
// module id = 1426
// module chunks = 2